import { render, staticRenderFns } from "./FireArm.vue?vue&type=template&id=d6631152"
import script from "./FireArm.vue?vue&type=script&lang=js"
export * from "./FireArm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports